export default __webpack_public_path__ + "static/media/spinner.86194a55.svg";